import { render, staticRenderFns } from "./ProductTitle.vue?vue&type=template&id=c5a5c2e6&scoped=true"
import script from "./ProductTitle.vue?vue&type=script&lang=ts"
export * from "./ProductTitle.vue?vue&type=script&lang=ts"
import style0 from "./ProductTitle.vue?vue&type=style&index=0&id=c5a5c2e6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5a5c2e6",
  null
  
)

export default component.exports